import { Component, OnInit, Input } from '@angular/core';
import { Product } from '../../models/Product';
import { FavoritesService } from '../../services/favorites.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  @Input() product: Product;
  isFav: boolean;
  logos =
    {
      'Djak Sport': 'assets/djaklogo1_mini.svg',
      'Planeta Sport': 'assets/logo_planeta_mini.svg',
      'N Sport': 'assets/logo_nsport_web_mini.svg',
      'Sport Vision': 'assets/sport_vision_logo_mini.png',
      Buzz: 'assets/buzz_logo.png'
    };
  constructor(private favoritesService: FavoritesService, public router: Router) {}

  ngOnInit() {
    this.isFav = this.favoritesService.getFromLocalStorage().indexOf(this.product.productCode.trim()) >= 0;
  }

  addToFavorites() {
    if (!this.isFav) {
    this.favoritesService.storeOnLocalStorage(this.product.productCode);
    } else {
      this.favoritesService.removeFromLocalStorage(this.product.productCode);
    }
    this.isFav = !this.isFav;
  }

  goToPage(event) {
    if (event.target.id !== 'btn') {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate(['/item', this.product.productCode]));
    }
  }
  openLink(link) {
    window.open(link, '_blank');
  }
}
